import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const newPaperApi = {
  getNewPapers: (params) => {
    const url = "newspapers";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getNewPaper: (id) => {
    const url = "newspapers";
    return axiosClient.get(url + "/" + id);
  },

  createNewPaper: (params) => {
    const url = "newspapers";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updateNewPaper: (id, payload) => {
    const url = "newspapers/";
    return axiosClient.patch(url + id, payload);
  },
  deleteNewPaper: (params) => {
    const url = "newspapers";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default newPaperApi;
